import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { get_note } from "./actions/action-notes";
import NotesCard from "./common/NotesCard";
import HeaderInner from "./HeaderInner";
import configureStore from "../../../store/configureStore";
import { history } from "../../../reducers";
import Footer from "./Footer";
import CommonSnackBar from "../../common/CommonSnackBar";

const store = configureStore();

export default function Notes() {
  const { activeOuid } = store.getState().permission;
  const dispatch = useDispatch();
  const { notes, showGlobalLoader } = useSelector((state) => state.note);

  function renderNotesList(notes) {
    if (notes) {
      return notes.map((item) => <NotesCard key={item.id} item={item} />);
    } else {
      return <>No notes found</>;
    }
  }

  useEffect(() => {
    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_note("", activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Notes " onClick={() => {history.push("/")}}/>
      <div className="AppPage container--narrow mt pb">
        {showGlobalLoader ? <Loader /> : renderNotesList(notes)}

        <div className="AppFloatingButtonWrapper">
          <button
            className="w-100  secondary_btn"
            onClick={() => history.push(`/${activeOuid}/add-notes`)}
          >
            Add Notes
          </button>
        </div>
      </div>
      <Footer />
      <CommonSnackBar />
    </div>
  );
}
